module.exports = __webpack_public_path__ + "img/user-placeholder.3b1c7e32.png";